import { supabase } from './supabase';

export interface TwoFaStatus {
  required: boolean;
  deadline: string | null;
  enrolled: boolean;
  days_left: number | null;
  overdue: boolean;
}

/** From this many days left, the notice can no longer be dismissed. */
export const URGENT_DAYS = 3;

export type TwoFaPrompt = 'none' | 'banner' | 'blocked';

/** What to show a signed-in person: nothing, a notice with days left, or only the setup screen. */
export function promptFor(s: TwoFaStatus | null): TwoFaPrompt {
  if (!s || !s.required || s.enrolled) return 'none';
  return s.overdue ? 'blocked' : 'banner';
}

export function bannerMessage(s: TwoFaStatus): string {
  const by = s.deadline
    ? new Date(s.deadline).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', timeZone: 'UTC' })
    : null;
  const left = s.days_left ?? 0;
  const when = left <= 0 ? 'today' : left === 1 ? 'in 1 day' : `within ${left} days`;
  return `Set up two-factor authentication ${when}${by ? ` (by ${by})` : ''}.`;
}

export async function fetchTwoFaStatus(): Promise<TwoFaStatus | null> {
  const { data, error } = await supabase.rpc('two_fa_status');
  if (error) return null;
  const row = (Array.isArray(data) ? data[0] : data) as TwoFaStatus | null | undefined;
  return row ?? null;
}

// Settings and the setup screen tell the requirement check that 2FA changed.
const EVENT = 'sekretly:2fa-changed';
export function notifyTwoFaChanged(): void {
  if (typeof window !== 'undefined') window.dispatchEvent(new Event(EVENT));
}
export function onTwoFaChanged(cb: () => void): () => void {
  window.addEventListener(EVENT, cb);
  return () => window.removeEventListener(EVENT, cb);
}
